import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-lab-test-item.reducer';

export const UserLabTestItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userLabTestItemEntity = useAppSelector(state => state.userLabTestItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userLabTestItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userLabTestItem.detail.title">UserLabTestItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.microSec}</dd>
          <dt>
            <span id="result">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.result">Result</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.result}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.timestampentry}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.observation}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.cursor}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.instructions}</dd>
          <dt>
            <span id="readingType">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.readingType">Reading Type</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.readingType}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="limits">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.limits">Limits</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.limits}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.statusCode}</dd>
          <dt>
            <span id="groupPanelId">
              <Translate contentKey="tinyMedicRestApp.userLabTestItem.groupPanelId">Group Panel Id</Translate>
            </span>
          </dt>
          <dd>{userLabTestItemEntity.groupPanelId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{userLabTestItemEntity.glucoUser ? userLabTestItemEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.category">Category</Translate>
          </dt>
          <dd>{userLabTestItemEntity.category ? userLabTestItemEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.item">Item</Translate>
          </dt>
          <dd>{userLabTestItemEntity.item ? userLabTestItemEntity.item.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.labPres">Lab Pres</Translate>
          </dt>
          <dd>{userLabTestItemEntity.labPres ? userLabTestItemEntity.labPres.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.recommendedAntibiotic">Recommended Antibiotic</Translate>
          </dt>
          <dd>{userLabTestItemEntity.recommendedAntibiotic ? userLabTestItemEntity.recommendedAntibiotic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-lab-test-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-lab-test-item/${userLabTestItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserLabTestItemDetail;
